import { render, staticRenderFns } from "./FavoriteList.vue?vue&type=template&id=d23af2fa&scoped=true&"
import script from "./FavoriteList.vue?vue&type=script&lang=js&"
export * from "./FavoriteList.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteList.vue?vue&type=style&index=0&id=d23af2fa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23af2fa",
  null
  
)

export default component.exports